import {Component, EventEmitter, OnInit, Output, Input} from '@angular/core';
declare var $;

@Component({
  selector: 'app-modal-pop-up',
  templateUrl: './modal-pop-up.component.html',
  styleUrls: ['./modal-pop-up.component.scss']
})
export class ModalPopUpComponent implements OnInit {
  @Input('responseMessage') responseMessage: any;
  @Output('triggerCloseEvent') closeEvent = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    $('.backspinner').css('height', $(document).innerHeight() + 'px');
  }
  
  public closePopUp(): void {
    this.closeEvent.emit();
  }

}
